/*
 *	101sauna.ru (v.2.0)
 *	@author:	Andrew Judis Pasarian
 */
var order = '';
var order2 = 'Cardsview';
var part = '';
var names = '';
var arraySaun;
var nextSaun = 0;
var YandexGeocod;//кординаты широта и долгота для 2GIS,берем из яндекса

$.post('/api.post/structure_site.check_view_return', {},
    function (data) {
        order2 = data;

    });

/*
 * Функция отображения "тени"
 */


shadow = function () {
    $('.hider').css('height', $(document).height() + 'px');
    $('.hider').show();
}

/*
 * Проверка на булево значение
 */
isBool = function (data) {
    if (data === undefined) {
        return false;
    } else {
        return true;
    }
}

/*
 * Функция отображения загрузчика
 */
loader = function () {
    $('.loader').css('position', 'fixed');
    $('.loader').css('top', ($(window).height() / 2) - 50);
    $('.loader').css('left', ($(window).width() / 2) - 50);
    $('.loader').css('width', '100px');
    $('.loader').css('height', '100px');

    $('.loader').show();
};

/*
 * Функция вывода сообщения
 */
showMSG = function (MSG, time) {
    if (time == undefined) time = 1500;

    $('.error').css('position', 'fixed');
    $('.error').css('top', ($(window).height() / 2) - 55);
    $('.error').css('left', ($(window).width() / 2) - 150);
    // $('.error').css('width', '300px');
    // $('.error').css('height', '150px');

    $('.errorMSG').html(MSG);
    $('.error').show();

    $('.errorMSG').css('margin-top', (110 - $('.errorMSG').height()) / 2);

    setTimeout(function () {
        $('.error').fadeOut('slow');
    }, time);
};


/*
 * Функция получения названий саун города
 */
getNames = function () {
    $.post(
        '/api.post/structure_site.getNames',
        {
            city: $('#citySelect').data('value')
        },
        function (data) {
            names = data;
            $('#name').autocomplete({
                source: names,
                select: function (event, ui) {
                    $('#name').val(ui.item.value);
                    search();
                }
            });
        },
        'json'
    );
}

/*
 * Реализация поиска через AJAX
 */
search = function () {
    if (part == null) {
        part = ''
    }
    ;
    // Проверяем на какой странице мы находимся
    // Если это страница с карточками
    if ($('.cards').size() > 0) {
        // То запускаем поиск
        loader();
        if (!$('#name').val() == '') {
            part = '';
        }
        var tempTpl = "search";
        if (order2 == "Cardsview") {
            tempTpl = "search";

        }
        if (order2 == "cardsList") {
            tempTpl = "search2";

        }
        if (order2 == "CardsOnMap") {
            tempTpl = "search3";

        }
        $.post(
            $('#citySelect').data('url') + '/:tpl_page-' + tempTpl + part,
            {
                search: 'true',
                city: $('#citySelect').data('value'),
                state: $('#stateSelect').data('value'),
                station: $('#stationSelect').data('value'),
                type: $('#typeSelect').data('value'),
                minPrice: $('#minPay').val(),
                maxPrice: $('#maxPay').val(),
                order: order,
                part: part,
                name: $('#name').val()
            },
            function (data) {
                $('.loader').hide();
                // Загружаем данные
                if (data == '' && order2 != "CardsOnMap") {

                    $('.cards').html('<div class="emptySearch">К сожалению по вашему запросу ничего не найдено! Попробуйте изменить параметры поиска или нажмите "Все гостиницы и номера"</div>');
                } else {

                    $('.cards').html("").append(data);
                    if (order2 == "CardsOnMap" && $("#globalMaps").text() == "") {
                        console.log(data)
                        $('.cards').prepend('<div class="emptySearch">К сожалению по вашему запросу ничего не найдено! Попробуйте изменить параметры поиска или нажмите "Все гостиницы и номера"</div>');
                    }
                    if ($('.cards .vcard').size() == 0 && order2 != "CardsOnMap") {
                        $('.cards').prepend('<div class="emptySearch">К сожалению по вашему запросу ничего не найдено! Попробуйте изменить параметры поиска или нажмите "Все гостиницы и номера"</div>');
                    }
                    var temporalCartAbout = $('.saunaTemporal').html();


                    //подгружаем нижнюю часть
                    $('.text').html(temporalCartAbout);
                    //вставляем в нее название города
                    $('.text .tempCity').html($("#citySelect").html())
                    var temporal = $("#citySelect").html();
                    var temporal2 = temporal.split(" ");
                    for (i = 0; i < temporal2.length; i++) {
                        //alert("<<<"+temp2[i]+">>>")
                        if (temporal2[i] == "Москва") {
                            temporal = "Москва"
                        }
                    }
                    // $(".h1TempCity").html(" " + temporal);

                    //очищаем переменный контент
                    $('.saunaTemporal').remove();


                    // Подсвечиваем активную сортировку
                    if (order == 'rating') {
                        $('#orderRating').addClass('active');
                    }
                    if (order == 'price') {
                        $('#orderPrice').addClass('active');
                    }
                    if (order == 'name') {
                        $('#orderName').addClass('active');
                    }
                    $("#" + order2).addClass("activeSort");


                    // Прокручиваем на уровень первого результата
                    if ($(window).scrollTop() > 150) {
                        if ($.browser.safari) {
                            $('body').animate({scrollTop: 0}, 500);
                        } else {
                            $('html').animate({scrollTop: 0}, 500);
                        }
                    }

                }
            }
        );

        // В противном случае
    } else {
        $.post(
            '/api.post/structure_site.setFilter',
            {
                city: $('#citySelect').data('value'),
                state: $('#stateSelect').data('value'),
                station: $('#stationSelect').data('value'),
                type: $('#typeSelect').data('value'),
                minPrice: $('#minPay').val(),
                maxPrice: $('#maxPay').val(),
                order: order,
                part: part,
                name: $('#name').val()
            },
            function () {
                // Отправляем на соответствующую страницу города с карточками
                // и подставляем параметры поиска в строку GET-параметров
//				parametr = '?search=true&city='+$('#citySelect').data('value')+'&state='+$('#stateSelect').data('value')+'&station='+$('#stationSelect').data('value')+'&type='+$('#typeSelect').data('value')+'&minPrice='+$('#minPay').val()+'&maxPrice='+$('#maxPay').val()+'&order='+order+'&name='+$('#name').val();
                window.location.href = $('#citySelect').data('url');
            }
        );
    }

}
if ($(".LastSaun .break").data("break") == "ok") {
    $(".load_next").remove();
}

$(document).ready(function () {
    /*
     *Подстановка названия города в Нижнюю часть шаблона default
     */
    if ($(".LastSaun .break").data("break") != "ok") {
        $(".load_next").show();
    }
    var temp = $("#citySelect").text();
    var temp2 = temp.split(" ");
    for (i = 0; i < temp2.length; i++) {
        //alert("<<<"+temp2[i]+">>>")
        if (temp2[i] == "\nМосква") {
            temp = "Москва"
        }
    }
    // $(".h1TempCity").html(temp);

    /*
     * Отчистка мелочей
     */
    if ($('.feedback').size() == 1) {
        $('.showAllFeedbacks').hide();
        $('.feedHeader').hide();
    }


    $('#minPay, #maxPay').change(function () {
        $(".slider").slider("option", "values", [$('#minPay').val(), $('#maxPay').val()]);
    });

    /*
     * Загрузка параметров поиска из сессии
     */
    loader();
    $.post('/api.post/structure_site.getSearchParametr', {},
        function (data) {
            $("#" + data.orderView).addClass("activeSort");
            $('.loader').hide();
            if (data && data.city) {
                var curIndexPart = location.pathname.lastIndexOf('/');
                if (location.pathname.slice(curIndexPart, curIndexPart + 7) == '/:part-' &&
                    location.pathname.slice(curIndexPart + 7) - 0
                ) {
                    part = location.pathname.slice(curIndexPart + 1);
                } else {
                    part = data.part;
                }

                // Выставляем город
                if (!($('#citySelect').data('value') == data.city) && data.city) {
                    $('#citySelect').text($('.citySelect').find('a[data-value="' + data.city + '"]').text());
                    $('#citySelect').data('value', $('.citySelect').find('a[data-value="' + data.city + '"]').data('value'));
                    $('#citySelect').data('url', $('.citySelect').find('a[data-value="' + data.city + '"]').attr('href'));
                }
                // Выставляем район
                if (!($('#stateSelect').data('value') == data.state) && data.state) {
                    $('#stateSelect').text($('.stateSelect').find('a[data-value="' + data.state + '"]').text());
                    $('#stateSelect').data('value', $('.stateSelect').find('a[data-value="' + data.state + '"]').data('value'));
                }
                // Выставляем остановку
                if (!($('#stationSelect').data('value') == data.station) && data.station) {
                    $('#stationSelect').text($('.stationSelect').find('a[data-value="' + data.station + '"]').text());
                    $('#stationSelect').data('value', $('.stationSelect').find('a[data-value="' + data.station + '"]').data('value'));
                }
                // Выставляем тип парной
                if (!($('#typeSelect').data('value') == data.type) && data.type) {
                    $('#typeSelect').text($('.typeSelect').find('a[data-value="' + data.type + '"]').text());
                    $('#typeSelect').data('value', $('.typeSelect').find('a[data-value="' + data.type + '"]').data('value'));
                }
                // Выставляем минимальную цену
                if (!($('#minPay').val() == data.minPrice)) {
                    $('#minPay').val(data.minPrice);
                }
                // Выставляем максимальную цену
                if (!($('#maxPay').val() == data.maxPrice)) {
                    $('#maxPay').val(data.maxPrice);
                }

                if ($('#minPay').val() == '') {
                    $('#minPay').val(settings_101.search.minPay);
                }
                if ($('#maxPay').val() == '') {
                    $('#maxPay').val(settings_101.search.maxPay);
                }

                $('#name').val(data.name);

                // Загрузка названий саун города
                getNames();

                if (!(part == '') && $('.cards').size() > 0) {
                    search();
                }

                if (data.name != '' && $('.cards').size() > 0) {
                    search();
                }

            } else {
                getNames();
            }


            /*
             *	Подключение слайдера цены
             */
            $(".slider").slider({
                range: true,
                min: settings_101.search.minPay,
                max: settings_101.search.maxPay,
                step: 100,
                values: [$('#minPay').val(), $('#maxPay').val()],
                slide: function (event, ui) {
                    $('#minPay').val(ui.values[0]);
                    $('#maxPay').val(ui.values[1]);
                },
                change: function (event, ui) {
                    part = '';
                    search();
                }
            });
        },
        'json'
    );


    /*
     * Привязка поиска по названию при нажатии Enter
     */
    $('#name').keydown(function (e) {
        if (e.keyCode == 13) {
            search();
        }
    });


    /*
     * Реализация ниспадающих списков выбора значения
     */
    $('#citySelect, #stateSelect, #stationSelect, #typeSelect').click(function () {
        shadow();
        $('.' + $(this).attr('id')).slideDown();
    });

    // клик на "тень" для сворачивания списка
    $('.hider').click(function () {
        $('.citySelect').slideUp();
        $('.stateSelect').slideUp();
        $('.stationSelect').slideUp();
        $('.typeSelect').slideUp();
        $('.hider').hide();
    });

    // Выбор значения
    $('.searchDD a').live('click', function () {
        $('.hider').click();
        loader();
        $('#' + $(this).parent().parent().data('target'))
            .text($(this).text())
            .data("value", $(this).data('value'));


        History.pushState(null, null, $(this).attr('href'));

        part = '';
        // Если выбрали другой город
        if ($(this).parent().parent().data('target') == 'citySelect') {

            order = '';
            $('#name').val('');
            $('#stateSelect').text('Не имеет значения').data('value', '');
            $('#typeSelect').text('Не имеет значения').data('value', '');

            // Выставляем идентификатор
            $('#' + $(this).parent().parent().data('target'))
                .data("url", $(this).attr('href'));

            getNames();
            // Загружаем районы города
            $.post(
                '/api.post/structure_site.getState',
                {
                    city: $('#citySelect').data('value')
                },
                function (data) {
                    $('.stateSelect').html(data);
                }
            );


            // Загружаем районы города
            $.post(
                '/api.post/structure_site.getStation',
                {
                    city: $('#citySelect').data('value')
                },
                function (data) {
                    $('.stationSelect').html(data);
                }
            );

            // Загружаем типы парных
            $.post(
                '/api.post/structure_site.getType',
                {
                    city: $('#citySelect').data('value')
                },
                function (data) {
                    $('.typeSelect').html(data);
                }
            );

            // Отправляем данные серверу
            $.post(
                '/api.post/structure_site.setCity',
                {
                    city: $('#citySelect').data('value')
                },
                function (data) {
                    search();
                }
            );


            // Иначе просто запускаем поиск
        } else {
            search();
        }
        return false;

    });

    /*
     * Реализация AJAX-листалки
     */
    $('#part-nav').delegate('a', 'click', function () {
        part = $(this).data("part");
        search();
        return false;
    });

    function addPartAndSearch(op) {
        var newPart = part.slice(6) - 0 + op - 0;
        console.log(newPart, $('#part-nav .pageNav').length + 1);
        var partsTemp = $.trim($('#part-nav .pagerNav:last').text())
        if (newPart > 0 && newPart <= partsTemp) {
            part = ':part-' + newPart;
            history.pushState(null, null, $("#citySelect").data("url") + "/" + part);
            search();
        }
    }

    $(".pagerNav").live("click", function () {
        part = $(this).data("part");
        history.pushState(null, null, $("#citySelect").data("url") + "/" + part);
        search();
        return false;


    })
    $(window).keydown(function (event) {
        if (event.ctrlKey) {
            switch (event.which) {
                case 37:
                    addPartAndSearch(-1);
                    break;
                case 39:
                    addPartAndSearch(1);
                    break;
            }
        }
    });

    /*
     * Реализация AJAX-сортировки
     */
    $('.order a').live('click', function () {
        if ($(this).hasClass('active')) {
            order = '';
        } else {
            order = $(this).data('order');
        }
        var a = $(this).attr("id");
        if (a == "Cardsview" || a == "cardsList") {
            $("#newMap").remove();
            $("#newStyle").remove();
            $("#drawJs").remove();
            $("#mapMan").remove();
            order2 = $(this).attr("id");
            $.post('/api.post/structure_site.check_view', {
                    orderView: $(this).attr("id")
                },
                function (data) {
                });
        }
        if (a == "CardsOnMap") {
            order2 = $(this).attr("id");

            var style = document.createElement("link");
            style.type = "text/css";
            style.id = "newStyle";
            style.rel = "stylesheet";
            style.href = "/site/css/map_draw.css";
            document.head.appendChild(style);
            //var mapMan = document.createElement("script");
            //mapMan.type = "text/javascript";
            //mapMan.id = "mapMan";
            //mapMan.src = "/site/js/map_manager.js";
            //document.body.appendChild(mapMan);
            //var drawJs = document.createElement("script");
            //drawJs.type = "text/javascript";
            //drawJs.id = "drawJs";
            //drawJs.src = "/site/js/draw.js";
            //document.body.appendChild(drawJs);
        }
        search();
        return false;
    });

    $('.navigate__fast-btn a').live("click", function () {
        part = $(this).data("part");
        history.pushState(null, null, $("#citySelect").data("url") + "/" + part);
        search();
        return false;


    })

    /*
     * Реализация отображения карты с отметкой заведения
     */
    if ($('#map').size() > 0) {
        YMaps.jQuery(window).load(function () {
            var map = new YMaps.Map(YMaps.jQuery("#map")[0]);
            map.setCenter(new YMaps.GeoPoint(37.619899, 55.753676), 10, YMaps.MapType.MAP);
            map.addControl(new YMaps.Zoom());
            map.addControl(new YMaps.ToolBar());
            YMaps.MapType.PMAP.getName = function () {
                return "Народная";
            };
            map.addControl(new YMaps.TypeControl([
                YMaps.MapType.MAP,
                YMaps.MapType.SATELLITE,
                YMaps.MapType.HYBRID,
                YMaps.MapType.PMAP
            ], [0, 1, 2, 3]));

            function createObject(type, point, style, description) {
                var allowObjects = ["Placemark", "Polyline", "Polygon"],
                    index = YMaps.jQuery.inArray(type, allowObjects),
                    constructor = allowObjects[(index == -1) ? 0 : index];
                description = description || "";

                var object = new YMaps[constructor](point, {style: style, hasBalloon: !!description});
                object.description = description;

                return object;
            }

            var geocoder = new YMaps.Geocoder($('#citySelect').text() + ", " + $('.street-address').text());

            var s = new YMaps.Style();
            s.iconStyle = new YMaps.IconStyle();
            s.iconStyle.href = "/site/images/mapMarkers/blue.png";
            s.iconStyle.size = new YMaps.Point(23, 40);
            s.iconStyle.offset = new YMaps.Point(-10, -31);

            YMaps.Events.observe(geocoder, geocoder.Events.Load, function (geocoder) {
                var placemark = new YMaps.Placemark(geocoder.get(0).getGeoPoint());
                //Вставка для 2GIS-->
                YandexGeocod = geocoder.get(0).getGeoPoint();
                $("#map3").attr({"data-map": YandexGeocod})
                //<--Вставка для 2GIS
                placemark.name = $('.fn').text();
                placemark.description = $('.street-address').text();
                placemark.setOptions({
                    style: s
                });

                map.addOverlay(placemark);
                map.setBounds(geocoder.get(0).getBounds());
            });
        });
    }


    /*
     * Реализация предпросмотра фотографий
     */
    $('.small img').hover(function () {
        if (!($('.big img').attr('src') == $(this).attr('src').replace('min', 'med'))) {
            $('.big img').attr('src', $(this).attr('src').replace('min', 'med'));
        }
    }, function () {

    });


    /*
     * Реализация просмотра фотографий
     */
    $("a[rel^='prettyPhoto']").prettyPhoto({
        gallery_markup: ''
    });
    var my_pretty_title = $("h1 span:eq(0)").text() + ", " +
        $("h1 span:eq(1)").text() + ". " +
        $.trim($("#citySelect").text()) + ". " +
        $(".street-address").text() + ". | //" + window.location.hostname + ""
        + $("#citySelect").data("url") + " | " +
        "Фотография: ";
    $("a[rel^='prettyPhoto']").each(function (i) {
        var a = $(this).attr("title");
        $(this).attr({"title": my_pretty_title + (i + 1 + ", " + a)})
        $(this).find("img").attr({"alt": my_pretty_title + (i + 1)})
    });


    /*
     * Реализация перехода по клику на карточку
     */
    $('.saunaCard').live('click', function () {
        var link = $(this).find('a').attr('href');
        var win = window.open(link, '_self');
        //win.focus();
        // window.location.href = $(this).find('a').attr('href');
    });

    /*
     * Реализация голосования
     */
    $('.votePlus').live('click', function () {
        loader();
        $.post(
            '/api.post/structure_site.votePlus',
            {
                id: $('.rating').data('saunaid')
            },
            function (data) {
                $('.loader').hide();
                if (data == 'ok') {
                    $('#rating').text(parseInt($('#rating').text()) + 1);
                } else {
                    showMSG('Вы уже голосовали!');
                }
            }
        );
        return false;
    });

    $('.voteMinus').live('click', function () {
        loader();
        $.post(
            '/api.post/structure_site.voteMinus',
            {
                id: $('.rating').data('saunaid')
            },
            function (data) {
                $('.loader').hide();
                if (data == 'ok') {
                    $('#rating').text(parseInt($('#rating').text()) - 1);
                } else {
                    showMSG('Вы уже голосовали!');
                }
            }
        );
        return false;
    });
    /*
     * Реализация скрытых телефонов со счетчиком
     */

    $('.telbtn').live('click', function () {
        var tel_span_class = $('.tel');
        var social_div_class = $('.data .socialLinks');
        var tel_btn_class = $("button.telbtn");
        if (tel_span_class.is(':hidden') && social_div_class.is(':hidden')) {
            $.post(
                '/api.post/structure_site.telCntAdd',
                {
                    id: $('.rating').data('saunaid'),
                    uagent: navigator.userAgent
                }
            );
            tel_span_class.show();
            social_div_class.show();
            sociallinks(".data");
            tel_btn_class.remove();
        }
        return false;
    });
    /*
     * Реализация отправки отзыва
     */
    $('.feedbackForm button, .callbackForm button').live('click', function () {
        var save = true;
        var msg = '';
        var type = "callback";
        if ($(this).parent().parent().parent().hasClass('feedbackForm')) {
            type = "feedback";
        }

        if (type == 'feedback') {
            name = $('#fb_name').val();
            mail = $('#fb_mail').val();
            phone = $('#fb_phone').val();
            text = $('#fb_text').val();
            mailTo = $('#mailTo').val();


        } else {
            name = $('#cb_name').val();
            mail = $('#cb_mail').val();
            phone = $('#cb_phone').val();
            text = $('#cb_text').val();
        }

        if (name == '') {
            save = false;
            msg = 'Введите имя';
        }

        if (mail == '') {
            save = false;
            if (msg == '') {
                msg = 'Введите e-mail';
            } else {
                msg += ', e-mail';
            }
        }

        if (text == '') {
            save = false;
            if (msg == '') {
                msg = 'Введите отзыв';
            } else {
                msg += ', отзыв';
            }
        }

        if (save) {
            loader();
            $.post(
                '/api.post/structure_site.addFeedback',
                {
                    id: $(this).parent().parent().parent().data('feedbackid'),
                    type: type,
                    author: name,
                    mail: mail,
                    phone: phone,
                    text: text,
                    urlSauna: window.location.href,
                    parentTitle: $('h1').text(),
                    mailTo: mailTo
                },
                function (data) {
                    if (data == 'ok') {
                        showMSG('Ваш отзыв успешно добавлен!');

                        $.post(
                            window.location.href + '/:tpl_page-system/feedback',
                            {},
                            function (data) {
                                $('.loader').hide();
                                $('.feedbackSection').html(data);
                                $('#fb_name').val('');
                                $('#fb_mail').val('');
                                $('#fb_phone').val('');
                                $('#fb_text').val('');
                            }
                        );
                    } else {
                        showMSG('При сохранении сообщения произошла ошибка!');
                    }
                }
            );
        } else {
            showMSG(msg);
        }

        return false;
    });


    /*
     * Реализация вывода всех отзывов
     */
    $('.showAllFeedbacks').live('click', function () {
        address = window.location.href;
        if (address.indexOf('#') > 0) {
            address = address.substring(0, address.indexOf('#'));
        }
        loader();
        $.post(
            address + '/:tpl_page-system/feedback',
            {},
            function (data) {
                $('.loader').hide();
                $('.feedbackSection').html(data);
                $('#fb_name').val('');
                $('#fb_mail').val('');
                $('#fb_phone').val('');
                $('#fb_text').val('');
            }
        );
        return false;
    });


    /*
     * Реализация ответа на комментарий
     */
    $('.callBack').live('click', function () {
        $('.callBack').show();
        $('.callbackForm').remove();
        $(this).after('<div class="callbackForm"><h2>Ваш ответ:</h2><form><div class="small"><label>Имя:<br /><input type="text" name="name" id="cb_name" placeholder="Андрей Андреев" /></label><label>E-mail:<br /><input type="text" name="mail" id="cb_mail" placeholder="login@domain.com" /></label><label>Телефон:<br /><input type="text" name="phone" id="cb_phone" placeholder="+7 999 999 99 99" /></label></div><div class="big"><label>Отзыв:<br /><textarea name="text" id="cb_text" placeholder="Текст вашего отзыва"></textarea></label><button>Отправить</button></div><div class="clear"></div></form></div>');
        $('.callbackForm').data('feedbackid', $(this).data('feedbackid'));
        $(this).hide();

        $('.feedbackForm').hide();
        $('.newFeedback').show();
        return false;
    });
    $('.newFeedback').live('click', function () {
        $(this).hide();
        $('.feedbackForm').show();
        $('.callBack').show();
        $('.callbackForm').remove();
        return false;
    });


    /*
     * Реализация добавления в закладки и социальных ссылок
     */
    $('#bookmark').click(function () {
        showMSG("Нажмите CTRL-D, чтобы добавить страницу в закладки.", 2500);
        return false;
    });
    function sociallinks(basetag) {
        basetag = basetag || "header";
        //$('#slVK').attr('href', '//vkontakte.ru/share.php?url=' + window.location.href);
        $(basetag + ' #slVK').attr('href', '//vkontakte.ru/share.php?url=' + window.location.href);
        $(basetag + ' #slFB').attr('href', '//www.facebook.com/sharer.php?u=' + window.location.href);
        $(basetag + ' #slTw').attr('href', '//twitter.com/home/?status=' + $('html title').text() + ' ' + window.location.href);
        $(basetag + ' #slLJ').attr('href', '//www.livejournal.com/update.bml?event=' + window.location.href + '&subject=' + $('html title').text());
        $(basetag + ' #slOd').attr('href', '//www.odnoklassniki.ru/dk?st.cmd=addShare&st._surl=' + window.location.href);
        $(basetag + ' #slMM').attr('href', '//connect.mail.ru/share?url=' + window.location.href + '&title=' + $('html title').text() + '&description=&imageurl=');
        $(basetag + ' #slYa').attr('href', 'whatsapp://send?text=' + window.location.href + ' ' + $('html title').text());
        /*('#slYa').attr('href','//my.ya.ru/posts_add_link.xml?URL='+window.location.href+'&title='+$('html title').text()+'&body=');*/
    }

    sociallinks("header");

    /*
     * Реализация отправки сообщения из подвала
     */
    $('#fbSend').click(function () {
        save = true;
        error = '';

        if ($('#fbName').val() == '') {
            save = false;
            error = 'Введите имя';
        }
        if ($('#fbMail').val() == '') {
            save = false;
            if (error == '') {
                error = 'Введите e-mail';
            } else {
                error += ', e-mail';
            }
        }
        if ($('#fbQuest').val() == '') {
            save = false;
            if (error == '') {
                error = 'Введите свой вопрос';
            } else {
                error += ' и свой вопрос';
            }
        }

        if (save) {
            loader();
            $.post(
                '/api.post/structure_site.sendMsgSupport',
                {
                    author: $('#fbName').val(),
                    mail: $('#fbMail').val(),
                    phone: $('#fbPhone').val(),
                    text: $('#fbQuest').val(),
                    grecaptcharesponse: $('#g-recaptcha-response').val()
                },
                function (data) {
                    $('.loader').hide();
                    if (data == 'ok') {
                        showMSG('Ваш вопрос успешно отправлен!');
                        $('#fbName').val('');
                        $('#fbMail').val('');
                        $('#fbPhone').val('');
                        $('#fbQuest').val('');
                    } else {
                        showMSG('При отправке сообщения произошла ошибка!');
                    }
                }
            );
        } else {
            showMSG(error);
        }
        return false;
    });


    /*
     * Реализация добавления новой сауны
     */
    $('#add-new-sauna').each(function () {

        var $form = $(this),
            photos = 0,
            numbers = 0;

        // $('#contactMail').attr('name', 'contactMail' + $form.data('key'));

        $form.find('.addPhoto').click(function () {
            photos++;
            $(this).parent().children('.fotos').append('<div class="imageCont"><div class="fotoTitle">Фотография ' + photos + '</div><label>Фотография*:<input type="file" name="image' + photos + '" class="image" /></label><label>Подпись:<input type="text" name="imageTitle' + photos + '" class="imageTitle" /></label></div>');
        });
        $form.find('.addNumber').click(function () {
            numbers++;
            $(this).parent().children('.numbers').append('<div class="imageCont"><div class="numbersTitle">Номер ' + numbers + '</div><label>Название*:<input type="text" name="numberTitle' + numbers + '" class="numberTitle" /></label><label>Вместимость*:<input type="text" name="numberVmestimost' + numbers + '" class="numberVmestimost" /></label><label>Тип парной*:<input type="text" name="numberType' + numbers + '" class="numberType" /></label><label>Минимальная цена*:<input type="text" name="numberminPrice' + numbers + '" class="numberminPrice" /></label><label>Максимальная цена*:<input type="text" name="numbermaxPrice' + numbers + '" class="numbermaxPrice" /></label><label>Услуги*:<input type="text" name="numberservices' + numbers + '" class="numberservices" /></label><label class="textarea">Описание номера*:<textarea name="numberabout' + numbers + '" class="numberAbout"></textarea></label></div>');
        });

        $form.submit(function () {

            var error = false;

            $form.find('input[type=text],textarea').each(function () {

                var $inp = $(this),
                    val = $.trim($inp.val());

                $inp.val(val);
                if (val == '') {
                    error = true;
                    return false;
                }
            });

            if (error) {
                showMSG('Заполните все обязательные поля!', 4000);
                return false;
            }
        });
    });


    /*
     * Реализация сброса фильтра
     */
    $('#clearFilter').click(function () {

        order = '';
        part = '';
        $('#name').val('');
        $('#stateSelect').text('Не имеет значения').data('value', '');
        $('#stationSelect').text('Не имеет значения').data('value', '');
        $('#typeSelect').text('Не имеет значения').data('value', '');

        $('#minPay').val(settings_101.search.minPay);
        $('#maxPay').val(settings_101.search.maxPay);

        $(".slider").slider("option", "values", [settings_101.search.minPay, settings_101.search.maxPay]);

        // Выставляем идентификатор
        $('#' + $(this).parent().parent().data('target'))
            .data("url", $(this).attr('href'));

        $.post(
            '/api.post/structure_site.filterReset',
            {},
            function (data) {
            }
        );
        // Загружаем районы города
        $.post(
            '/api.post/structure_site.getState',
            {
                city: $('#citySelect').data('value')
            },
            function (data) {
                $('.stateSelect').html(data);
                // Загружаем районы города

                $.post(
                    '/api.post/structure_site.getStation',
                    {
                        city: $('#citySelect').data('value')
                    },
                    function (data) {
                        $('.stationSelect').html(data);
                        // Загружаем типы парных
                        $.post(
                            '/api.post/structure_site.getType',
                            {
                                city: $('#citySelect').data('value')
                            },
                            function (data) {
                                $('.typeSelect').html(data);
                                var a = "//" + window.location.hostname + $("#citySelect").data("url")
                                history.pushState(null, null, a);
                                order2 = 'Cardsview';


                                search();


                            }
                        );
                    }
                );
            }
        );
        return false;
    });


    /*
     * Возврат к результатам поиска
     */
    $('#backToResults').click(function () {
        search();
    });


    /*
     * Функционал набивалки
     */
    $('#edit').live('click', function () {
        if ($('#nabivalka').css('display') == 'none') {
            $('#nabivalka').show();
        } else {
            $('#nabivalka').hide();
        }
    });

    $('#nabivalkaSave').live('click', function () {

        var data = 'id=' + $('#edit').attr('data-number') + '&';

        $('#nabivalka input[type="text"]').each(function () {
            data += $(this).attr('name') + "=" + $(this).val() + "&";
        });

        $('#nabivalka input[type="checkbox"]').each(function () {
            data += $(this).attr('name') + "=" + isBool($(this).attr('checked')) + "&";
        });

        data += 'address=' + $('input[name="street"]').val() + ', ' + $('input[name="house"]').val();

        parnaya = '';
        $('.parnaya:checked').each(function () {
            if (parnaya == '') {
                parnaya += $(this).parent().text();
            } else {
                parnaya += ', ' + $(this).parent().text();
            }
        });

        data += '&type=' + parnaya;

        data += '&vmestimost=' + $('input[name="maxCount"]').val();

        jQuery.post(
            '/api.post/structure_site.saveSauna',
            data,
            function (data) {
                alert(data);
            }
        );

    });


    /*
     * Иниицализация функций ВКонтакте


     VK.init(function() {
     VK.callMethod("resizeWindow", 775, $('body').height());
     });*/


    //Загружаем массив с саунами
    arraySaun = $(".tempAraySaunes").text();
    arraySaun = arraySaun.split(",");

    //проверяем колличество выборки
    if (arraySaun.length == 2) {
        $(".navigation_saun").hide("slow");
    }

    //чистим строку-массив

    $(".tempAraySaunes").remove();

    //пробегаемся по массиву с url страниц, ищем совпадения
    for (i = 1; i < arraySaun.length - 1; i++) {
        if ($("#sectionSaun .saunaUrl").data('url') == arraySaun[i]) {
            nextSaun = i;

            break;
        }
    }

});


//Смена изображений стрелок и их кэширование, Аякс листалки
var imageArrowTemp = [];
for (i = 0; i < 4; i++) {
    imageArrowTemp[i] = new Image();
}
imageArrowTemp[0].src = "/site/images/ears-next2.png";
imageArrowTemp[1].src = "/site/images/ears-next1.png";
imageArrowTemp[2].src = "/site/images/ears-prev2.png";
imageArrowTemp[3].src = "/site/images/ears-next1.png";

//Аякс листалка
$("#next_link").hover(function () {

        $(this).find("img").attr({"src": "/site/images/ears-next2.png"});
    }
    , function () {
        $(this).find("img").attr({"src": "/site/images/ears-next1.png"});


    })
$("#prev_link").hover(function () {
        $(this).find("img").attr({"src": "/site/images/ears-prev2.png"});
    }
    , function () {
        $(this).find("img").attr({"src": "/site/images/ears-prev1.png"});


    })

$("#next_link").click(function () {


//Если losder скрыт
    if ($('.loader').css("display") == "none") {
        nextSaun++;

        if (nextSaun > arraySaun.length - 1) {
            nextSaun = 1;
        }

        $('.loader').show();
        //подгружаем строку с классами страниц и разбиваем в массив
        var arraySaun2 = $(".tempAray2Saunes").text();
        arraySaun2 = arraySaun2.split(",");
        $(".tempAray2Saunes").remove();
        //собираем запрос для формирования страницы
        $.get(arraySaun[nextSaun] + "/:tpl_page-" + arraySaun2[nextSaun] + "Ajax",
            {},
            function (data2) {
                //перемещаем карту, после загрузки страницы вставим обратно
                $("footer").append($("#map"));
                $(".saunaInfo .banner script").remove();
                $("footer").append($(".saunaInfo .banner"));
                history.pushState(null, null, arraySaun[nextSaun]);
                $("#sectionSaun").html(data2);

                $("#mapTemp").append($("#map"));
                $(".bannerTwo").append($("footer .banner"));

                $('.loader').hide();

                AfterAjaxInit();
            }
        );
    }

});


$("#prev_link").click(function () {
//Если losder скрыт
    if ($('.loader').css("display") == "none") {

        nextSaun--;

        if (nextSaun < 1) {
            nextSaun = arraySaun.length - 1;
        }

        $('.loader').show();
        //подгружаем строку с классами страниц и разбиваем в массив
        var arraySaun2 = $(".tempAray2Saunes").text();
        arraySaun2 = arraySaun2.split(",");
        $(".tempAray2Saunes").remove();

        //собираем запрос для формирования страницы
        $.get(arraySaun[nextSaun] + "/:tpl_page-" + arraySaun2[nextSaun] + "Ajax",
            {},
            function (data2) {
                //перемещаем карту, после загрузки страницы вставим обратно
                $("footer").append($("#map"));
                $(".saunaInfo .banner script").remove();
                $("footer").append($(".saunaInfo .banner"));
                history.pushState(null, null, arraySaun[nextSaun]);
                $("#sectionSaun").html(data2);

                $("#mapTemp").append($("#map"));
                $(".bannerTwo").append($("footer .banner"));


                $('.loader').hide();

                AfterAjaxInit();
            }
        );

    }

});


function AfterAjaxInit() {

    $("#map").show();
    //Инициализируем подгруженные элементы - prettyFoto, yandex карты, реклама

    $('.small img').hover(function () {
        if (!($('.big img').attr('src') == $(this).attr('src').replace('min', 'med'))) {
            $('.big img').attr('src', $(this).attr('src').replace('min', 'med'));
        }
    }, function () {

    });


    /*
     * Реализация просмотра фотографий
     */
    $("a[rel^='prettyPhoto']").prettyPhoto({
        gallery_markup: ""
    });

    var my_pretty_title = $("h1 span:eq(0)").text() + ", " +
        $("h1 span:eq(1)").text() + ". " +
        $.trim($("#citySelect").text()) + ". " +
        $(".street-address").text() + ". | //" + window.location.hostname
        + $("#citySelect").data("url") + " | " +
        "Фотография: ";
    $("a[rel^='prettyPhoto']").each(function (i) {
        var a = $(this).attr("title");
        $(this).attr({"title": my_pretty_title + (i + 1) + ", " + a})
        $(this).find("img").attr({"alt": my_pretty_title + (i + 1)})
    });


    var map = new YMaps.Map(YMaps.jQuery("#map")[0]);
    map.setCenter(new YMaps.GeoPoint(37.619899, 55.753676), 10, YMaps.MapType.MAP);
    map.addControl(new YMaps.Zoom());
    map.addControl(new YMaps.ToolBar());
    YMaps.MapType.PMAP.getName = function () {
        return "Народная";
    };
    map.addControl(new YMaps.TypeControl([
        YMaps.MapType.MAP,
        YMaps.MapType.SATELLITE,
        YMaps.MapType.HYBRID,
        YMaps.MapType.PMAP
    ], [0, 1, 2, 3]));

    function createObject(type, point, style, description) {
        var allowObjects = ["Placemark", "Polyline", "Polygon"],
            index = YMaps.jQuery.inArray(type, allowObjects),
            constructor = allowObjects[(index == -1) ? 0 : index];
        description = description || "";

        var object = new YMaps[constructor](point, {style: style, hasBalloon: !!description});
        object.description = description;

        return object;
    }

    var geocoder = new YMaps.Geocoder($('#citySelect').text() + ", " + $('.street-address').text());

    var s = new YMaps.Style();
    s.iconStyle = new YMaps.IconStyle();
    s.iconStyle.href = "/site/images/mapMarkers/blue.png";
    s.iconStyle.size = new YMaps.Point(23, 40);
    s.iconStyle.offset = new YMaps.Point(-10, -31);

    YMaps.Events.observe(geocoder, geocoder.Events.Load, function (geocoder) {
        var placemark = new YMaps.Placemark(geocoder.get(0).getGeoPoint());
        YandexGeocod = geocoder.get(0).getGeoPoint();
        $("#map3").attr({"data-map": YandexGeocod})

        placemark.name = $('.fn').text();
        placemark.description = $('.street-address').text();
        placemark.setOptions({
            style: s
        });

        map.addOverlay(placemark);
        map.setBounds(geocoder.get(0).getBounds());
    });


    // document.getElementById("i-facebook").height =  document.getElementById("i-facebook").contentWindow.document.body.scrollHeight;


    (function (d, s, id) {
        var atemp = window.location;
        $(".fb-comments").attr({'data-href': atemp});
        var js, fjs = d.getElementsByTagName(s)[0];

        if (d.getElementById(id)) return;

        js = d.createElement(s);
        js.id = id;

        js.src = "//connect.facebook.net/ru_RU/all.js#xfbml=1";

        fjs.parentNode.insertBefore(js, fjs);

    }(document, 'script', 'facebook-jssdk'));
    //общая прокрутка в начало
    if ($.browser.safari) {
        $('body').animate({scrollTop: $("#section").height()}, 500);
    } else {
        $('html').animate({scrollTop: $("#section").height()}, 500);
    }

}


$(".load_next").click(function () {
    var part = $(this).attr("data-part") + 9;

    $.post(
        '/api.post/structure_site.getlastVisit',
        {
            part: part
        },
        function (data) {
            var a = $(".load_next").attr("data-part") * 1;
            $(".LastSaun").append(data);
            $(".load_next").attr({"data-part": part})
            if ($(".LastSaun .break").data("break") == "ok") {
                $(".load_next").remove();

            }
        }
    );

})

$("#Googlmap").live("click", function () {
    $("#map,#map3").hide();
    $("#map2").show();
    $("#Googlmap, #Yashamap, #GISmap").removeClass("active");
    $(this).addClass("active");
    initialize();


})
var geocoder;
var map;

function initialize() {
    var adress = $(".street-address").text();
    var city = $("#citySelect").val();
    $.post(
        '//maps.googleapis.com/maps/api/geocode/json?address=' + adress + ',' + city + '&sensor=false',
        function (data) {
            var YandexGeocod = $("#map3").data("map");
            YandexGeocod = YandexGeocod.split(",");

            var lng = YandexGeocod[0] * 1;
            var lat = YandexGeocod[1] * 1;
            var latlng = new google.maps.LatLng(lat, lng);
            var mapOptions = {
                zoom: 16,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }

            var map = new google.maps.Map(document.getElementById("map2"),
                mapOptions);
            var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter(),
                title: adress
            });
            var message = "<b>" + $(".fn .category").text() + " " + $(".fn span:eq(1)").text() + "</b><br>" +
                "<span>" + $(".street-address").text() + "</span>";

            ;
            var infowindow = new google.maps.InfoWindow({
                content: message
            });

            google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(marker.get('map'), marker);
            });
        },
        'json'
    );

}
function attachSecretMessage() {

}
$("#Yashamap").live("click", function () {
    $("#map2,#map3").hide();
    $("#map").show();
    $("#Googlmap, #Yashamap, #GISmap").removeClass("active");
    $(this).addClass("active");

})
$("#GISmap").live("click", function () {
    $("#map,#map2").hide();
    $("#map3").show();
    $("#Googlmap, #Yashamap, #GISmap").removeClass("active");
    $(this).addClass("active");

    mapLoad()
})
function mapLoad() {
    DG.then(function () {
        var elem = $("#map3").data("map");
        var YandexGeocod = elem.split(",");
        // Инициализируем карту, устанавливаем её центр и масштаб:
        var dgmap = DG.map('map3', {
            'center': [YandexGeocod[1] * 1, YandexGeocod[0] * 1],
            'zoom': 16
        });
        YandexGeocod[0] = YandexGeocod[0] * 1;
        YandexGeocod[1] = YandexGeocod[1] * 1;
        var bankList = [{
            "lon": YandexGeocod[1],
            "lat": YandexGeocod[0],
            "address": $(".street-address").text(),
            "name": $(".fn>span:eq(1)").text() + " " + $(".fn>span:eq(0)").text()
        }
        ];
        // Опции маркера
        var bank = bankList[0];
        var info = "<b>" + bank.name + "</b><br>" + bank.address;

        var myIcon = DG.icon({
            iconUrl: '/site/images/mapMarkers/blue.png',
            iconSize: [22, 37]
        });

        DG.marker([bank.lon, bank.lat], {
            icon: myIcon
        }).addTo(dgmap).bindPopup(info);

    });
}


$(".LastSaun i").live("click", function () {
    window.open($(this).data("href"));

})
$(".LastSaun a").live("click", function () {
    event.preventDefault();

})
//functional
$(".Lable_online_reserv").live("click", function () {
    $("#sectionSaun .container").hide("slow");
    $("#sectionSaun .container2").show("slow");
    if ($('#Online_saunaid').val() == "" && $('#Online_saunaid').data("to") == "") {
        $(".online-status").html("Данная сауна не указала обратных координат<br>К сожалению, вы не можете отправить сообщение");
    }
    $('#Online_costTime').mask('с 99:99 до 99:99');
    if (!(typeof settings_101.bronform === 'undefined' || settings_101.bronform === null || typeof settings_101.bronform.telmask === 'undefined' || settings_101.bronform.telmask === null)) {
        $("#Online_costPhone").mask(settings_101.bronform.telmask);
    } else {
        $("#Online_costPhone").mask("8 (999) 999 99 99");
    }

});

$("#returnOnline_cost").live("click", function () {
    $("#sectionSaun .container2").hide("slow");
    $("#sectionSaun .container").show("slow");

});
$(".Lable_online_reserv").live("click", function () {
    $("#Online_costDate").datepicker();

});


/* send reservation of number */
$("#Online_cost-form").live('submit', function (e) {

    e.preventDefault();

    var save = true;

    $(this).parents('form').find('input, textarea').each(function () {
        if ($(this).val() == '') {
            save = false;
            $(this).parents('.control-group').addClass('errorForm');
        } else {
            $(this).parents('.control-group').removeClass('errorForm');
        }
    });

    if ($('#Online_saunaid').val() == '') {
        showMSG("Вы не можете отправить сообщение, у данной сауны не указаны данные", 5000);
    } else {
        if (save) {
            var saun = $('h1 span:eq(1)').text();
            if (saun == null) {
                saun = '';
            }
            jQuery.post('/api.post/structure_site.send_onlineReservation',
                {
                    name: $('#Online_costName').val(),
                    email: $('#Online_costEmail').val(),
                    phone: $('#Online_costPhone').val(),
                    date: $('#Online_costDate').val(),
                    count: $('#Online_costCount').val(),
                    time: $('#Online_costTime').val(),
                    number: $('#Online_costNumber').val(),
                    saun: saun,
                    _url_: location.href,
                    saunaid: $('#Online_saunaid').val(),
                },
                function (data) {
                    var arr;
                    arr = JSON.parse(data);
                    switch (arr.rettype) {
                        case 'ok':
                            delete arr.rettype;
                            send_sms();
                            $('#Online_cost-form').find('input, textarea').each(function () {
                                var elem = $(this);
                                if(elem.attr('id') != "Online_saunaid"){
                                    elem.val('');
                                }
                            })
                            $("#sectionSaun .container2").hide("slow");
                            $("#sectionSaun .container").show("slow");
                            showMSG('Сообщение успешно отправлено.', 3000);
                            break;
                        case 'vfail':
                            var mess = '';
                            delete arr.rettype;
                            for (var key in arr) {
                                if (arr.hasOwnProperty(key)) {
                                    mess += key + ": " + arr[key] + "<br>";
                                }
                            }
                            showMSG(mess, 7000);
                            break;
                        default:
                            showMSG('При отправке сообщения произошла ошибка. Повторите попытку позже!', 3000);
                            break;
                    }
                }
            );

        }
    }

    return false;
});

function send_sms() {
    var
        $pnone = $('#sauna-nab-phone'),
        numbers = $.trim($pnone.val() + ',' + $pnone.data('contact')),
        saun = $('#Online_costNumber').val();

    if (saun == null) saun = '';

    $.post(
        '/api.post/structure_site.send_onlineSms',
        {
            name: $('#Online_costName').val(),
            email: $('#Online_costEmail').val(),
            phone: $('#Online_costPhone').val(),
            date: $('#Online_costDate').val(),
            count: $('#Online_costCount').val(),
            time: $('#Online_costTime').val(),
            number: saun,
            saunaid: $('#Online_saunaid').val()
        },
        function (data) {
        }
    );
}

$(function HiddenEmptyMetro() {
    var val = document.getElementById('stationvalue');
    // console.log(val);
    // console.log(val.value);
    if (val && !val.innerHTML) {
        // console.log("Element "+val+" found");
        var div = document.getElementById('station');
        div.innerHTML = "";
        delete div;
    } else {
        // console.log("Element "+val+"not found");
    }
});

$(function GetClInfo() {
    new Fingerprint2().get(function(result){
        if(!Cookies.get('CHASH')){
            Cookies.set('CHASH',result)
        }
    });
});
